import { render } from "./TenantEditWorkflowStatusDialog.vue?vue&type=template&id=5cfbc1a3"
import script from "./TenantEditWorkflowStatusDialog.vue?vue&type=script&lang=js"
export * from "./TenantEditWorkflowStatusDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__